import * as React from "react"
import * as HoverCardPrimitive from "@radix-ui/react-hover-card"

import { cn } from "@/lib/utils"

const HoverCard = HoverCardPrimitive.Root

const HoverCardTrigger = HoverCardPrimitive.Trigger

const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof HoverCardPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content> & {
    /** Enable/disable scale animations (zoom-in/out). Default: true */
    animateScale?: boolean
    /** Enable/disable fade animations. Default: true */
    animateFade?: boolean
  }
>(({ className, align = "center", sideOffset = 4, animateScale = true, animateFade = true, ...props }, ref) => {
  const base = "z-50 w-64 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none"
  const slide =
    "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-hover-card-content-transform-origin]"
  const fade = "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
  const scale = "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95"

  return (
    <HoverCardPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        base,
        // radix adds animate-in/out; keep them, but control specific effects
        "data-[state=open]:animate-in data-[state=closed]:animate-out",
        slide,
        animateFade && fade,
        animateScale && scale,
        className,
      )}
      {...props}
    />
  )
})
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName

export { HoverCard, HoverCardTrigger, HoverCardContent }
